import { createContext, useContext, useEffect, useState } from "react";

export const TranslationContext = createContext();

// List of supported languages
const SUPPORTED_LANGUAGES = [
  "en", "es", "fr", "de", "zh-CN", "ja","zh-TW"

  // you can add more
];

export function TranslationProvider({ children }) {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (!window.googleTranslateScriptAdded) {
      const script = document.createElement("script");
      script.src = "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
      script.async = true;
      document.body.appendChild(script);

      window.googleTranslateScriptAdded = true;
    }

    window.googleTranslateElementInit = () => {
      if (!window.google || !window.google.translate) {
        console.error("Google Translate not available yet");
        return;
      }

      new window.google.translate.TranslateElement(
        {
          pageLanguage: "en",
          autoDisplay: false,
        },
        "google_translate_element"
      );
      setLoaded(true);

      // After loading, auto-pick user language
      setTimeout(() => {
        autoPickUserLanguage();
      }, 500); // small delay to allow Google to fully inject select
    };
  }, []);

  const changeLanguage = (langCode) => {
    const select = document.querySelector(".goog-te-combo");
    if (select) {
      select.value = langCode;
      select.dispatchEvent(new Event("change"));
    } else {
      console.error("Google Translate dropdown not found.");
    }
  };

  const autoPickUserLanguage = () => {
    const userLang = navigator.language || navigator.userLanguage;
    //console.log("Detected browser language:", userLang);

    const normalizedLang = userLang.split("-")[0]; // ex: "en-US" ➔ "en"

    let selectedLang = "";

    // Try exact match first
    if (SUPPORTED_LANGUAGES.includes(userLang)) {
      selectedLang = userLang;
    }
    // Try normalized language
    else if (SUPPORTED_LANGUAGES.includes(normalizedLang)) {
      selectedLang = normalizedLang;
    }

    // If a supported language was found, trigger translation
    if (selectedLang && selectedLang !== "en") {
     // console.log("Auto-switching language to:", selectedLang);
      changeLanguage(selectedLang);
    } else {
      //console.log("No language auto-switch needed, staying at default.");
    }
  };

  return (
    <TranslationContext.Provider value={{ loaded, changeLanguage }}>
      <div id="google_translate_element" style={{ display: "none" }} />
      {children}
    </TranslationContext.Provider>
  );
}
